import React, { useEffect, useState } from 'react';
import { Business } from '../../../models/Business';
import {
  Alert,
  Card,
  Col,
  Row,
} from 'antd';
import { FirebaseObject } from "../../../models/FirebasePostObject";
import { format } from 'date-fns';
import Loading from '../../../components/Loading';
import DescriptionItem from './DescriptionItem';
import * as Database from "../../../config/Firebase";

export type Props = {
  business: Business | undefined;
}

enum Status {
  Idle,
  Loading,
  Loaded,
  Error,
}

const BusinessDetails: React.FC<Props> = ({ business }) => {
  const [firebaseBusiness, setFirebaseBusiness] = useState<FirebaseObject<Business, any>>();
  const [status, setStatus] = useState(Status.Idle);

  useEffect(() => {
    if (!business) return;
    if (status !== Status.Idle) return;

    setStatus(Status.Loading);

    Database.ref(`/${business.code}`).then((b) => {
      b.once("value", async (obj) => {
        const tree: {
          Business?: {
            [key: string]: FirebaseObject<Business>;
          };
        } | null = obj.val();

        if (tree?.Business) {
          const firebaseBusiness: FirebaseObject<Business> = Object.entries(
            tree.Business
          )[0][1];

          setFirebaseBusiness(firebaseBusiness);
        }
        setStatus(Status.Loaded);
      });
    }).catch((error) => {
      console.error(error);
      setStatus(Status.Error)
    });
  }, [business, status]);

  if (status === Status.Error) return <Alert type="error" message="Failed to load business details" />
  if (status === Status.Loading) return <Loading tip="Loading business." />

  const name = firebaseBusiness?.data.attributes.nameLegal;
  const isOwner = firebaseBusiness?.data.attributes.isOwner;

  return (
    <Card bodyStyle={{ padding: 0 }}>
      <div className="p-4">
        {firebaseBusiness
          ? <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <DescriptionItem
                title="Business name:"
                content={name}
              />
            </Col>
            <Col xs={24} sm={12}>
              <DescriptionItem
                title="Owner:"
                content={isOwner ? 'Yes' : 'No'}
              />
            </Col>
          </Row>
          : <Row gutter={[16, 16]}>
            <Col xs={24} sm={12}>
              <i>No business details found</i>
            </Col>
          </Row>
        }
      </div>
    </Card>
  )
}

export default BusinessDetails;
